/* General imports */
import React from 'react';
import { ThemeContext } from '../../providers/theme';
import styled from 'styled-components';
import translate from '../../providers/i18n/translate';
import Button from '@mui/material/Button';

/* Styled components */
const FileUpload = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: auto;
    min-height: 150px;
    align-items: center;
    justify-content: space-evenly;
    span {
        text-align: center;
    }
`

function FileInput (props) {

    const theme = React.useContext(ThemeContext);

    const inputId = props.id ?? 'contained-button-file';

    const onChange = (e) => {
        props.onChange(e);
    }
    return (
        <FileUpload>
            <input
                id={inputId}
                name='attachment'
                type="file"
                style={{ display: "none" }}
                onChange={onChange}
                required={props.required}
                multiple={props.multiple}
            />
            <span>
                {typeof props.file === "string" ? props.file : props.file ? props.file.length > 1 ? `${props.file.length} files` : props.file[0].name : 
                    translate("No file selected")
                }
            </span>
            <label htmlFor={inputId}>
                <Button
                variant="contained"
                color="inherit"
                component="span"
                sx={{
                    color: "white",
                    backgroundColor: theme.palette.accent,
                    "&:hover": {
                        backgroundColor: theme.palette.principal,
                    },
                }}
                >
                    {
                        props.file ?
                        props.customButtonText?.replace ?? translate("Replace files")
                        :
                        props.customButtonText?.upload ?? translate("Upload files")
                    }
                </Button>
            </label>
        </FileUpload>
    );
}

export default FileInput;
